import { makeAutoObservable, runInAction } from "mobx";
import { adminRegisterServiceCenterInTBank } from "@pro-sto/api-client";
import { toastStore } from "../../../ToastStore";

// ─── Стор регистрации сервисного центра в Т-Банке ────────────────────────────

export class TBankSubStore {
  isRegistering = false;

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * Регистрирует СЦ как точку партнёра в Т-Банке.
   * onSuccess вызывается после успешной регистрации — используется для
   * обновления tbankRegisteredAt в LegalStatusStore.
   */
  register = async (uuid: string, onSuccess: () => void) => {
    if (!uuid || this.isRegistering) return;
    this.isRegistering = true;
    try {
      await adminRegisterServiceCenterInTBank({ serviceCenterUuid: uuid });
      runInAction(() => {
        this.isRegistering = false;
      });
      onSuccess();
    } catch (e: unknown) {
      runInAction(() => {
        this.isRegistering = false;
      });
      const status = (e as { status?: number })?.status;
      if (status === 400) {
        toastStore.showError("Не заполнены обязательные юридические данные");
      } else if (status === 409) {
        toastStore.showError("Точка уже зарегистрирована в Т-Банке");
      } else {
        toastStore.showError("Не удалось зарегистрировать в Т-Банке");
      }
    }
  };

  reset = () => {
    this.isRegistering = false;
  };
}
